import { render, staticRenderFns } from "./PhysicianViewAccountsCard.vue?vue&type=template&id=b36b7552&"
import script from "./PhysicianViewAccountsCard.vue?vue&type=script&lang=js&"
export * from "./PhysicianViewAccountsCard.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianViewAccountsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports